
































import { Component, Vue, Prop } from 'vue-property-decorator';
import { sanitizeEmail } from '@getaccept/lib-shared/src/helpers';
import type { AuthenticationStep } from '../../authentication/types/authentication-step';

@Component
export default class IdentifyRecipient extends Vue {
  @Prop() authStep!: AuthenticationStep;
  @Prop() submittingResponse!: boolean;

  email = '';

  get documentName() {
    return this.authStep.data.textData?.document?.name;
  }

  handleAnswer() {
    this.$emit('answer', { type: this.authStep.type, value: sanitizeEmail(this.email) });
  }
}
